import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { LogoutStatusService } from '@app/shared/services/logout-status.service';

import { BsModalRef } from 'ngx-bootstrap/modal';
import { AuthenticationService } from '../../../core/services/authentication.service';


@Component({
  selector: 'app-logout-adfs',
  templateUrl: './logout-adfs.component.html',
  styleUrls: ['./logout-adfs.component.css']
})
export class LogoutAdfsComponent {  

  @Input() url:string = '';
  isLogoutSuccess : boolean = false;
  externalLink : object;  

  constructor(
    private authenService: AuthenticationService,
    private router: Router,
    private modalRef: BsModalRef,
    private logoutStatusService: LogoutStatusService
    ){
      this.externalLink = JSON.parse(
        sessionStorage.getItem("externalLink") || "{}"
      );
  }

  ngOnInit(){
    this.logoutStatusService.isLogout = false;
    if(this.url == ''){            
      this.url = this.externalLink['logoutAdfs'];    
    }        
  }

  loaded() {
    if(this.logoutStatusService.isLogout) return;
    this.logoutStatusService.isLogout = true;
    this.authenService.logout().subscribe({next:(v)=> {      
      setTimeout(() => {
        this.modalRef.hide();              
        this.router.navigate(["/auth/login"]);        
      },1000);      
    },error: (e) => {}
    });    
  }
}